import { DesignSystemButtonSize } from '@upheal/design-system/theme/design-system/types';
import { RiCloseLine } from '@remixicon/react';
import { Button } from '../Button/Button';
import { RemixIcon } from '../Icon/RemixIcon';
import { buttonSizeValues } from '../Button/styleUtils';

const closeButtonSize: DesignSystemButtonSize = 'sm';
export const closeButtonSizeValues = buttonSizeValues[closeButtonSize];

const closeButtonTransform = `translateY(${
    -8 * (closeButtonSizeValues.paddingY as number)
}px)`;

type Props = {
    onClick: VoidFunction;
    alignment?: 'start' | 'end';
};

export const ModalCloseButton = ({ onClick, alignment = 'start' }: Props) => {
    return (
        <Button
            onClick={onClick}
            variant="ghost"
            size={closeButtonSize}
            iconOnly
            aria-label="Close"
            sx={{
                alignSelf: alignment === 'start' ? 'flex-start' : 'flex-end',
                transform: closeButtonTransform,

                '&:hover': {
                    transform: closeButtonTransform,
                },
            }}
        >
            <RemixIcon
                icon={RiCloseLine}
                color="ds.fg.neutral.tertiary"
                size="md"
            />
        </Button>
    );
};
